import { extractNumbers } from '@/utils/extract-numbers';

export const cepMask = (value: string = '') => {
  let cep = extractNumbers(value);

  if (cep) {
    cep = cep.replace(/\D/g, '');
    cep = cep.substring(0, 8);
    cep = cep.replace(/(\d)(\d{3})$/, '$1-$2');
    return cep;
  }
  return '';
};
